import { axiosInstance } from '../helpers';

const createResponseError = (response, fallbackMessage) => {
  const message = response?.data?.message
    || fallbackMessage
    || 'Dashboard request failed';
  const error = new Error(message);
  error.status = response?.status || 500;
  error.error = message;
  if (
    response?.data?.name === 'TokenExpiredError'
    || message === 'jwt expired'
  ) {
    error.code = 'invalidToken';
  }
  return error;
};

const getOverview = query => axiosInstance
  .get('/dashboard/overview', { params: query })
  .then(response => response.data)
  .catch((error) => {
    throw createResponseError(error.response, error.message);
  });

export const dashboardService = {
  getOverview,
};
